/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { Component } from "react";
import classes from "./stats.module.css";
import { connect } from "react-redux";
import actionTypes from "../../../store/actions";
import BusApiCall from "../../../helper/axios";
import constants from "../../../helper/constants";
import Loader from "../../../component/loader";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Tooltip from "@mui/material/Tooltip";
import Input from "../../../component/inputpm";
import IconButton from "@mui/material/IconButton";
import moment from "moment";

import { Switch, Route } from "react-router-dom";
import StatOrders from "./orders";
import Breadcrumb from "../../../component/breadcrumb";
import { SearchIcon, ClearIcon } from "../../../component/icons/icons";
import { withTranslation } from "react-i18next";
import { Grid } from "@mui/material";
import currencyFormatter from "../../../helper/currencyFormatter";
import { withNavigation } from "../../../helper/withNavigation";

// Manage subscription page parent class
class Stats extends Component {
  // Declare property values that belongs to the component
  state = {
    loading: false,
    orderStats: {},
    subscriptionStats: [],
    customerBAN: "",
    customerName: "",
    orderCustomerBan: "",
    orderCustomerName: "",
    selectedOrderStatData: {},
    selectedSubscriptionData: {},
    bread: [
      { title: this.props.t("REPORTS"), url: "/stats" },
      { title: this.props.t("ORDER_STATISTICS"), url: "/stats" },
    ],
  };

  // Intial HTTP calls or data manipulation on page load
  componentDidMount() {
    // Remove error message on component load
    this.props.setCompDidMount();
    this.getOrderStats();
  }

  getOrderStats = () => {
    this.setState({ loading: true });
    var jsonData = {
      customerBan: this.state.orderCustomerBan,
      customerName: this.state.orderCustomerName,
    };
    BusApiCall(
      "GET",
      `${constants.busInternalUrl}/reports?reportType=ORDER_STATS&customerBan=${this.state.orderCustomerBan}&customerName=${this.state.orderCustomerName}&jsonData=${JSON.stringify(jsonData)}`,
    )
      .then((res) => {
        this.setState({
          orderStats: res.data.orderStats ? res.data.orderStats : [],
        });
        this.getSubscriptionsStats();
      })
      .catch((err) => {
        this.getSubscriptionsStats();
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
      });
  };

  getSubscriptionsStats = () => {
    this.setState({ loading: true });
    BusApiCall(
      "GET",
      `${constants.busInternalUrl}/reports?reportType=SUBSCRIPTION_STATS&customerBan=${this.state.customerBAN}&customerName=${this.state.customerName}`,
    )
      .then((res) => {
        this.setState({
          subscriptionStats: res.data.subscriptionStats
            ? res.data.subscriptionStats.subStatusStats
            : [],
          loading: false,
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false });
      });
  };

  // Update state data on input change
  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  // Search subscription stats on press enter key
  onSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      this.getSubscriptionsStats();
    }
  };

  // Search order stats on press enter key
  onOrderSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      this.getOrderStats();
    }
  };

  // Clear subscription search filters
  clearSearchFilters = () => {
    this.setState(
      {
        customerBan: "",
        customerName: "",
      },
      () => this.getSubscriptionsStats(),
    );
  };

  // Clear order search filters
  clearOrderSearchFilters = () => {
    this.setState(
      {
        orderCustomerBan: "",
        orderCustomerName: "",
      },
      () => this.getOrderStats(),
    );
  };

  viewReport = (val, status) => {
    let from = "";
    if (val === "week") {
      from = moment().startOf("week").format("YYYY-MM-DDTHH:mm:ss:SSSZ");
    } else if (val === "month") {
      from = moment().startOf("month").format("YYYY-MM-DDTHH:mm:ss:SSSZ");
    } else if (val === "year") {
      from = moment().startOf("year").format("YYYY-MM-DDTHH:mm:ss:SSSZ");
    } else {
      from = moment()
        .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
        .format("YYYY-MM-DDTHH:mm:ss:SSSZ");
    }
    this.setState(
      {
        selectedOrderStatData: {
          from: from,
          to: moment().format("YYYY-MM-DDTHH:mm:ss:SSSZ"),

          customerBAN: this.state.orderCustomerBan,
          customerName: this.state.orderCustomerName,
          orderStatus: status,

          sortBy: "orderDate",
          sortOrder: "DESC",
          page: 1,
          startRecord: 1,
          rowsPerPage: 10,
        },
      },
      () => {
        // {props.publicBrowsing ? `/viewSolution/${props.product.productOfferingId}` : (props.providerType === 'SOLUTION_PROVIDER' && props.location.pathname === '/newOrder' ? { pathname: `${props.location.pathname}/${props.product.productOfferingId}`, state: props.tenantId } : `${props.location.pathname}/${props.product.productOfferingId}`)}
        // return;
        this.props.router.navigate({
          pathname: `${this.props.router.location.pathname}/orderReport`,
          state: this.state.selectedOrderStatData,
        });
      },
    );
  };

  viewSubscriptions = (val, status) => {
    let from = "";
    if (val === "week") {
      from = moment().startOf("week").format("YYYY-MM-DDTHH:mm:ss:SSZ");
    } else if (val === "month") {
      from = moment().startOf("month").format("YYYY-MM-DDTHH:mm:ss:SSZ");
    } else if (val === "year") {
      from = moment().startOf("year").format("YYYY-MM-DDTHH:mm:ss:SSZ");
    } else {
      from = moment()
        .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
        .format("YYYY-MM-DDTHH:mm:ss:SSZ");
    }
    this.props.router.navigate(
      `/subscription?from=${encodeURIComponent(from)}&to=${encodeURIComponent(moment().format("YYYY-MM-DDTHH:mm:ss:SSZ"))}&status=${status}&customerBAN=${this.state.customerBAN}&customerName=${this.state.customerName}&stats=true`,
    );
  };

  render() {
    const t = this.props.t;
    return (
      // this.props.match.isExact ?
      // :
      // <Switch>
      //     <Route path='/stats/orderReport' component={(props) =>
      //         <StatOrders statsData={this.state.selectedOrderStatData} {...props} />
      //     } />
      // </Switch>
      <div className={"newContentWrapper"}>
        <div className={"breadcrumbWrapper"}>
          <div className={"breadcrumbContent"}>
            <Grid container>
              <Grid
                item
                size={{
                  xs: 12,
                }}
              >
                <Breadcrumb list={this.state.bread} />
              </Grid>
            </Grid>
          </div>
        </div>
        <main>
          <Paper className="tablePaper" elevation={0}>
            <div
              className={classes.searchOuterDiv}
              style={{ marginBottom: "5px" }}
            >
              {this.props.providerType === "SALES_CHNL_PROVIDER" && (
                <div className={classes.searchInputDiv}>
                  <Input
                    placeholder={t("CUSTOMER_BAN")}
                    value={this.state.orderCustomerBan}
                    name={"orderCustomerBan"}
                    onChange={(e) => {
                      this.onChange(e);
                    }}
                    divClass={classes.inputClass}
                    onKeyDown={(e) => {
                      this.onOrderSearchKeyDown(e);
                    }}
                    size={"small"}
                    variant={"outlined"}
                  />
                </div>
              )}
              <div className={classes.searchInputDiv}>
                <Input
                  placeholder={t("CUSTOMER_NAME")}
                  value={this.state.orderCustomerName}
                  name={"orderCustomerName"}
                  onChange={(e) => {
                    this.onChange(e);
                  }}
                  divClass={classes.inputClass}
                  onKeyDown={(e) => {
                    this.onOrderSearchKeyDown(e);
                  }}
                  size={"small"}
                  variant={"outlined"}
                />
              </div>
              {/* <div className={classes.searchOrderLabelOuter}>
                                <div className={classes.searchOrderLabelInner}> */}
              <div style={{ display: "flex", alignItems: "flex-start" }}>
                <Tooltip title={t("SEARCH")}>
                  <IconButton
                    className="iconButtonSecondary"
                    onClick={this.getOrderStats}
                  >
                    <SearchIcon />
                  </IconButton>
                </Tooltip>{" "}
                &nbsp;
                <Tooltip title={t("CLEAR")}>
                  <IconButton
                    className="iconButtonSecondary"
                    onClick={this.clearOrderSearchFilters}
                  >
                    <ClearIcon />
                  </IconButton>
                </Tooltip>
              </div>
              {/* </div> */}
              {/* <div className='cl'></div> */}
            </div>
            {/* <div className={classes.filtersWrapper}>
                            <div className={classes.filterInput}>
                                <Input
                                    placeholder="Customer BAN"
                                    variant={'outlined'}
                                    value={this.state.orderCustomerBan}
                                    name={"orderCustomerBan"}
                                    onChange={(e) => { this.onChange(e) }}
                                    divClass={classes.inputClass}
                                    onKeyDown={(e) => { this.onOrderSearchKeyDown(e) }}
                                />
                            </div>
                            <div className={classes.filterInput}>
                                <Input
                                    placeholder="Customer Name"
                                    variant={'outlined'}
                                    value={this.state.orderCustomerName}
                                    name={"orderCustomerName"}
                                    onChange={(e) => { this.onChange(e) }}
                                    divClass={classes.inputClass}
                                    onKeyDown={(e) => { this.onOrderSearchKeyDown(e) }}
                                />
                            </div>
                            <div className={classes.filterActions}>
                                <IconButton onClick={this.getOrderStats}>
                                    <SearchIcon />
                                </IconButton>
                                <IconButton onClick={this.clearOrderSearchFilters}>
                                    <ClearIcon />
                                </IconButton>
                            </div>
                        </div> */}
            <TableContainer>
              <Table className={classes.statsTable + " " + "newGlobalTable"}>
                <TableHead>
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell align="center">{t("Today")}</TableCell>
                    <TableCell align="center">
                      <Tooltip title="Weekly-To-Date">
                        <span>{t("WTD")}</span>
                      </Tooltip>
                    </TableCell>
                    <TableCell align="center">
                      <Tooltip title="Monthly-To-Date">
                        <span>{t("MTD")}</span>
                      </Tooltip>
                    </TableCell>
                    <TableCell align="center">
                      <Tooltip title="Yearly-To-Date">
                        <span>{t("YTD")}</span>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.state.orderStats ? (
                    <>
                      {this.state.orderStats.orderStatusStatsList && (
                        <TableRow>
                          <TableCell>
                            <b>{t("ORDER_STATUS_COUNT")}</b>
                          </TableCell>
                          <TableCell colSpan={4}></TableCell>
                        </TableRow>
                      )}
                      {this.state.orderStats.orderStatusStatsList &&
                        this.state.orderStats.orderStatusStatsList.map(
                          (item, i) => (
                            <TableRow key={i}>
                              <TableCell className={classes.statsSubTitle}>
                                {item.orderStatus}
                              </TableCell>
                              <TableCell
                                align="center"
                                className={classes.reportsLink}
                                onClick={() => {
                                  this.viewReport("", item.orderStatus);
                                }}
                              >
                                {item.itemStatsData.todaysCout}
                              </TableCell>
                              <TableCell
                                align="center"
                                className={classes.reportsLink}
                                onClick={() => {
                                  this.viewReport("week", item.orderStatus);
                                }}
                              >
                                {item.itemStatsData.weeklyCout}
                              </TableCell>
                              <TableCell
                                align="center"
                                className={classes.reportsLink}
                                onClick={() => {
                                  this.viewReport("month", item.orderStatus);
                                }}
                              >
                                {item.itemStatsData.monthlyCout}
                              </TableCell>
                              <TableCell
                                align="center"
                                className={classes.reportsLink}
                                onClick={() => {
                                  this.viewReport("year", item.orderStatus);
                                }}
                              >
                                {item.itemStatsData.yearlyCout}
                              </TableCell>
                            </TableRow>
                          ),
                        )}
                      {this.state.orderStats.orderTotalStats &&
                        this.props.providerType === "SALES_CHNL_PROVIDER" && (
                          <TableRow>
                            <TableCell>
                              <b>{t("ORDER_TOTAL_AMOUNT")}</b>
                            </TableCell>
                            <TableCell align="center">
                              {currencyFormatter(
                                this.state.orderStats.orderTotalStats
                                  .todaysCout,
                              )}
                            </TableCell>
                            <TableCell align="center">
                              {currencyFormatter(
                                this.state.orderStats.orderTotalStats
                                  .weeklyCout,
                              )}
                            </TableCell>
                            <TableCell align="center">
                              {currencyFormatter(
                                this.state.orderStats.orderTotalStats
                                  .monthlyCout,
                              )}
                            </TableCell>
                            <TableCell align="center">
                              {currencyFormatter(
                                this.state.orderStats.orderTotalStats
                                  .yearlyCout,
                              )}
                            </TableCell>
                          </TableRow>
                        )}
                      {!this.state.orderStats.orderStatusStatsList &&
                        !this.state.orderStats.orderStatusStatsList &&
                        !this.state.orderStats.orderTotalStats && (
                          <TableRow>
                            <TableCell colSpan={5} align="center">
                              {t("NO_DATA_FOUND")}
                            </TableCell>
                          </TableRow>
                        )}
                    </>
                  ) : (
                    <>
                      <TableRow>
                        <TableCell colSpan={5} align="center">
                          {t("NO_DATA_FOUND")}
                        </TableCell>
                      </TableRow>
                    </>
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            {/* <br /><br />

                    <h4 align="center">Subscription Statistics</h4>

                    <div className={classes.filtersWrapper}>
                        <div className={classes.filterInput}>
                            <Input
                                placeholder="Customer BAN"
                                value={this.state.customerBAN}
                                name={"customerBAN"}
                                onChange={(e) => { this.onChange(e) }}
                                divClass={classes.inputClass}
                                onKeyDown={(e) => { this.onSearchKeyDown(e) }}
                            />
                        </div>
                        <div className={classes.filterInput}>
                            <Input
                                placeholder="Customer Name"
                                value={this.state.customerName}
                                name={"customerName"}
                                onChange={(e) => { this.onChange(e) }}
                                divClass={classes.inputClass}
                                onKeyDown={(e) => { this.onSearchKeyDown(e) }}
                            />
                        </div>
                        <div className={classes.filterActions}>
                            <IconButton onClick={this.getSubscriptionsStats}>
                                <SearchIcon />
                            </IconButton>
                            <IconButton onClick={this.clearSearchFilters}>
                                <ClearIcon />
                            </IconButton>
                        </div>
                    </div>

                    <TableContainer component={Paper}>
                        <Table className={classes.statsTable}>
                            <TableHead>
                                <TableRow>
                                    <TableCell></TableCell>
                                    <TableCell align="center">Today</TableCell>
                                    <TableCell align="center">
                                        <Tooltip title="Weekly-To-Date">
                                            <span>WTD</span>
                                        </Tooltip>
                                    </TableCell>
                                    <TableCell align="center">
                                        <Tooltip title="Monthly-To-Date">
                                            <span>MTD</span>
                                        </Tooltip>
                                    </TableCell>
                                    <TableCell align="center">
                                        <Tooltip title="Yearly-To-Date">
                                            <span>YTD</span>
                                        </Tooltip>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    this.state.subscriptionStats &&
                                    this.state.subscriptionStats.map((item, i) =>
                                        <TableRow key={i}>
                                            <TableCell className={classes.statsSubTitle}>{item.subscriptionStatus}</TableCell>
                                            <TableCell align="center" className={classes.reportsLink} onClick={() => { this.viewSubscriptions('', item.status) }}>{item.itemStatsData.todaysCout}</TableCell>
                                            <TableCell align="center" className={classes.reportsLink} onClick={() => { this.viewSubscriptions('week', item.status) }}>{item.itemStatsData.weeklyCout}</TableCell>
                                            <TableCell align="center" className={classes.reportsLink} onClick={() => { this.viewSubscriptions('month', item.status) }}>{item.itemStatsData.monthlyCout}</TableCell>
                                            <TableCell align="center" className={classes.reportsLink} onClick={() => { this.viewSubscriptions('year', item.status) }}>{item.itemStatsData.yearlyCout}</TableCell>
                                        </TableRow>
                                    )
                                }
                                {
                                    this.state.subscriptionStats.length === 0 &&
                                    <TableRow>
                                        <TableCell colSpan={5} align="center">
                                            No data found
                                        </TableCell>
                                    </TableRow>
                                }
                            </TableBody>
                        </Table>
                    </TableContainer> */}
          </Paper>
          <Loader loading={this.state.loading} />
        </main>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    providerType: state.auth.providerType,
  };
};

// Set data to redux store
const mapDispatchToProps = (dispatch) => {
  return {
    setCompDidMount: () =>
      dispatch({ type: actionTypes.GLOBAL_COMP_DID_MOUNT }),
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(withNavigation(Stats)));
